import React, { useState, useContext, useEffect } from "react";
import _ from "lodash";
import "react-circular-progressbar/dist/styles.css";
import ContentLoader from "react-content-loader";
import moment from "moment";

import useReactRouter from "use-react-router";
import { API } from "aws-amplify";
import { Page, Alert } from "components";
import { useTransition } from 'react-spring';
import {  DateRange, Button } from "components";
import ShopContext from "context/ShopContext";
import classNames from "lib/classNames";
import {  stateCards } from "lib/globals";
import styles from "styles/dashboard.module.scss";
import { formatMoney } from "components/cart/Utils";
import Thumbnail from "svgs/ship-video.png";

window.mo = moment;
const defaultStateCards = {
  AcceptedOffers: 0,
  ProtectionRevenue: 0,
  Conversion: 0,
  TotalROI: 0 ,
};

const DashboardScreen = () => {
  const { history, location } = useReactRouter();

  const [dateRangeFilter, setDateRangeFilter] = useState(null);
  const [count, setCount] = useState(defaultStateCards);

	const [isAppActive, setIsAppActive] = useState(false);

  const check = async () =>{
    const {status} = await API.get("API_GATEWAY_NEW", "/store/check");
    setIsAppActive(status)
  }
  useEffect(() => {
    const interval = setInterval(check , 5000);
    return () => clearInterval(interval);
  },[])
  useEffect(() => {
    check()
  },[])
  
  const getStatics = async () => {
    setCount(defaultStateCards);
    const dateFilter = dateRangeFilter
      ? {
          start: new Date(dateRangeFilter[0]).getTime(),
          end: new Date(dateRangeFilter[1]).getTime()
        }
      : {};
    const count = await API.get("API_GATEWAY_NEW", "/analytics/count", {
      queryStringParameters: Object.assign(
        {
         
        },
        dateFilter
      )
    });
    setCount(count);
  };

  useEffect(()=>{
    getStatics()
  },[dateRangeFilter])

	const transitions = useTransition(true, null, {
		from: { position: 'absolute', opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
	});

  return (
    <Page
    header={{
      title: "Dashboard",
      actions: []
    }}
    loading={{
      text: "Loading",
      status: false
    }}
    background="none"
    padding={0}
    TopContent={{
      transitions,
      render: ({ error, loading }) => (
        <Alert
						type="save_settings"
						title="Dashboard"
						borderPosition="none"
						paddingX="px-6"
            // actions={[
            //   {
            //     text: "Create/Edit offer",
            //     type: "primary",
            //     loading: false,
						// 		onClick: () => history.push("/settings" + location.search),
            //   }
            // ]}
            // withSwitch={{context: [shopContext, "settings.active"]}}
					/>
      )
    }}
  >

    <Alert
            type={isAppActive ? "success" : "warning"}
            icon={isAppActive ? "check-circle" : "exclamation-circle"}
            title={`ShipProtect is ${!isAppActive ? 'not activated on your theme': 'active on your theme'}` }
            className="z-5"
            actions={[
              {
                text: "Create/Edit offer",
                type: "primary",
                loading: false,
								onClick: () => history.push("/settings" + location.search),
              }
            ]}
            // withSwitch={{
            //   context: [shopContext, 'settings.active'],
            // }}
          >
            <p>
              {" "}
              This will automatically create or update this product in Shopify
              and add the offer widget to Cart
            </p>
          </Alert>
    <div className={styles.card}>
      <div  className={styles.title}>How it works?</div>
      <div  className={styles.content}>
        <div  className={styles.item}><span>1. </span> Customer adds insurance to order</div>
        <div className={styles.item}><span>2. </span> You collect payment like a normal product</div>
        <div className={styles.item}><span>3. </span> Customer can contact you for a claim</div>
      </div>
    </div>
    <div
      className={classNames(
        "grid grid-flow-row gap-4 grid-cols-1 lg:grid-cols-3"
      )}
    >
      <div
        className={classNames(
          "col-span-1 lg:col-span-3 flex items-center flex-wrap space-y-3 sm:space-y-0 sm:space-x-3"
        )}
      >
        <b className={classNames("flex-1 text-gray-600 text-lg")}>Stats</b> 
        <DateRange
          onChange={(range) => {
            setDateRangeFilter(range);
          }}
          maxDate={new Date()}
          value={dateRangeFilter}
          className={classNames("flex-auto w-full sm:flex-1")}
          button={{
            text: "Date Filter",
            icon: "calendar-alt"
          }}
        />
      </div>
      <div
        className={classNames(
          "col-span-1 lg:col-span-3 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        )}
      >
        {stateCards.map((stateCard, i) => (
          <StateCard
            {...stateCard}
            value={count[stateCard.title]}
            key={i}
            position={i + 1}
            onClick={() => { }}
          />
        ))}
        {/* <div  className={styles.createBtn}>
          <Button
            type="primary"
            onClick={(e) =>console.log(e)}
            text={"Create/Edit offer"}
            icon="cog"
          />
        </div> */}
      </div>
        <div
          className={classNames(
            "col-span-1 lg:col-span-3 flex items-center flex-wrap space-y-3 sm:space-y-0 sm:space-x-3"
          )}
        >
          <b className={classNames("flex-1 text-gray-600 text-lg")}> Setup guide</b> 
        </div>

      <div className={classNames('col-span-1 lg:col-span-3  ')}>
      {/* <iframe width="100%" height="600" src="https://www.youtube.com/embed/MBkeoitBK2E?si=soGw6V-9aVsgsbDJ" title="Setup guide" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
          <div 
            className={classNames("cursor-pointer")}
            onClick={() => window.open("https://www.youtube.com/watch?v=3KW6wM_DkyM&ab_channel=TyChapman","_blank")}
          >
            <img src={Thumbnail}  />
          </div>
					
				</div>
    </div>
  </Page>
  );
};


const StateCard = (props) => {
  const { title,label, value, suf, pre, onClick, active, currency, clickable } =
    props;
  const {
    state: { money_format }
  } = useContext(ShopContext);
  return (
    // <div className={styles.stateCard} {...{ position, onClick, active }}>
    <div
      className={classNames(
        "shadow flex-1 bg-white rounded-lg p-5 text-gray-600",
        {
          "text-blue-500 ring": active
        },
        {
          "cursor-pointer": clickable !== false
        }
      )}
      {...{ onClick, active }}
    >
      {value === null && (
        <ContentLoader>
          <rect x="0" y="0" rx="4" ry="4" width="60%" height="30" />
          <rect x="0" y="60" rx="4" ry="4" width="30%" height="30" />
        </ContentLoader>
      )}
      {typeof value === "number" && (
        <>
          <h3 className={classNames("font-bold mb-3")}>{label || _.startCase(title)}</h3>
          <h1 className={classNames("font-bold text-4xl")}>
            {pre && <i className={styles.pre}>{pre}</i>}{" "}
            {currency ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: formatMoney(value * 100, money_format)
                }}
              ></span>
            ) : (
              value
            )}{" "}
            {suf && <i className={styles.suf}>{suf}</i>}
          </h1>
        </>
      )}
    </div>
  );
};
DashboardScreen.propTypes = {};


export default DashboardScreen;
